import React, { useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import EbookLP from "../../components/ebooklp";
import EBook from "../../../images/landing/ebook.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";
import BgImg1 from "../../../images/landing/bg_ebook.jpg";

const EbookLanding = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section className="p-100 ebook_lp_secion" style={{ backgroundImage: `url(${BgImg1})` }}>
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
              <div className="ebook_title">DIGITAL TRENDS</div>
              <h4>
                Web Design <span style={{ color: "#eb5627" }} >Trends & 2024</span> Insights To Know
              </h4>
              <div className="btn_download" onClick={handleShow}>
                Download Now!
              </div>
            </Col>
            <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto text-center">
              <LazyLoadImage
                src={EBook}
                effect="blur"
                alt="tekrevol_EBook"
                className="img-fluid"
              />
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="modal_forms">
          <EbookLP setShow={setShow} />
        </div>
      </Modal>
    </>
  );
};

export default EbookLanding;
